import { Stack, Text } from "flicket-ui";
import PriceOrFree from "../../common/PriceOrFree";
import { PriceInfoProps } from "../types";
import { useOrganization } from "~hooks";

/**
 * Component to display price information based on current state
 */
export const PriceInfo = ({
  isExchangeFlow,
  ticketsLoading,
  hasSelection,
  showFees,
  cart,
  ownedTicketsExchangeValue,
}: PriceInfoProps) => {
  const { organization } = useOrganization();

  // HACK for the chili peppers flexi membership, hide downgrade message
  const flexiMembershipHideDowngrade =
    organization?.id === "9cf6fc7b-498d-44f2-b3b6-5ad7bdeb6cdb" ||
    organization?.id === "16602908-e0c4-4942-b541-0490dae79f53";

  if (isExchangeFlow && ticketsLoading) {
    return null;
  }

  if (hasSelection) {
    if (isExchangeFlow) {
      const isLesserExchangeValue =
        cart.total < ownedTicketsExchangeValue && !flexiMembershipHideDowngrade;

      return (
        <>
          <Text variant="header.Minor">Difference to pay</Text>
          <Stack gap="1/2" direction="horizontal" alignItems="baseline">
            <Text variant="header.S">
              <PriceOrFree
                price={cart.total}
                currency={organization.currency}
              />
            </Text>
            <Text variant="small">Including fees</Text>
          </Stack>
          {isLesserExchangeValue && (
            <Text variant="small">
              You have selected a lower-priced value.
              <br />
              The difference won&apos;t be refunded.
            </Text>
          )}
        </>
      );
    }

    return (
      <>
        <Text variant="header.S">
          <PriceOrFree price={cart.total} currency={organization.currency} />
        </Text>
        {showFees && cart.total > 0 && (
          <Text variant="small">Including fees</Text>
        )}
      </>
    );
  }

  return null;
};
